module.exports = __webpack_public_path__ + "img/1F92D.7267ffb2.svg";